import Banner from './banner/banner';
import { useNewPlan } from '../hooks/use-new-plan';
import Discover from './discover/discover';
import Benefits from './benefits/benefits';
import Footer from './footer/footer';
import { ContactButton } from '../../../components/contact-button/contact-button';
import Header from './header/header-new-plan';
import PlansTable from './plans-table/plans-table';
import HowWorksLine from './how-works/how-works';

const NewPlan = () => {
  const { whatsappLink, isFromCanal, isLowerPrice, isTaxi, titleBanner } =
    useNewPlan();

  return (
    <div className="new-plan">
      <Header isFromCanal={isFromCanal} />
      <Banner isFromCanal={isFromCanal} title={titleBanner} isTaxi={isTaxi} />
      <PlansTable isLowerPrice={isLowerPrice} isTaxi={isTaxi} />
      <HowWorksLine isLowerPrice={isLowerPrice} isTaxi={isTaxi} />
      <Discover isLowerPrice={isLowerPrice} isTaxi={isTaxi} />
      <Benefits isTaxi={isTaxi} />
      <Footer />
      <ContactButton link={whatsappLink} />
    </div>
  );
};

export default NewPlan;
